import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { RecordedStamp } from "@/admin/Recorded";
import { AdminTitle } from "@/admin/AdminLayout";
import { Switch } from "@/components/ui/switch";

export default function AdminPageNav() {
  const [items, setItems] = useState<any[]>([]);
  const [tick, setTick] = useState(0);
  const load = () => api.get("/admin-x/page-sections").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const flip = async (k: string, on: boolean) => {
    const next = items.map((x) => (x.key === k ? { ...x, on } : x));
    try { await api.put("/admin-x/page-nav", { off: next.filter((x) => !x.on).map((x) => x.key) }); setItems(next); setTick((t) => t + 1); toast(on ? "Previous / next buttons on" : "Previous / next buttons off"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="admin-page-nav">
      <AdminTitle title="Previous / Next Buttons" sub="Buttons at the end of each page’s text showing the previous and next page from the header menu (left to right, top to bottom through every column), so readers can carry on without going back to the menu."><RecordedStamp res="site" id="site" tick={tick} onRestored={load} testId="page-nav-stamp" /></AdminTitle>
      <div className="space-y-3 max-w-3xl">
        {items.map((s) => (
          <div key={s.key} className="border border-neutral-200 bg-white p-4 flex items-start gap-4" data-testid={`page-nav-row-${s.key.replace(/\W+/g, "-")}`}>
            <Switch checked={s.on} onCheckedChange={(v: boolean) => flip(s.key, v)} data-testid={`page-nav-switch-${s.key.replace(/\W+/g, "-")}`} />
            <div className="min-w-0"><p className="text-sm font-medium">{s.kind === "menu" ? `${s.title} menu — pages in menu order` : `${s.pages[0]} … — linked pages (used when a page isn't in the menu)`}</p>
              <p className="text-xs text-neutral-500 mt-1">{s.pages.join(" → ")}</p></div>
          </div>))}
      </div>
    </div>
  );
}
